<script setup>
import { getUserDetail } from "~/api/api";

const { $isMobile } = useNuxtApp();
const route = useRoute();
const teacherId = route.params.id;

// 获取老师信息用于SEO
const { data: teacherInfo } = await useLazyAsyncData(
	`teacher-${teacherId}`,
	async () => {
		try {
			const res = await getUserDetail({ uid: teacherId });
			return res.data || {};
		} catch (error) {
			console.error("获取老师信息失败:", error);
			return {};
		}
	},
	{
		default: () => ({}),
		server: true,
	}
);

definePageMeta({
	"m-showNavBar": false,
	"m-showFooter": false,
	"pc-showNavBar": true,
	"pc-showFooter": true,
	breadcrumbName: "teacherDetail.pc.breadcrumb",
});

// 响应式设置SEO头部信息
useHead({
	title: computed(() => teacherInfo.value?.nickname || "老師詳情 - 先知命局"),
	meta: [
		{
			name: "keywords",
			content: computed(
				() =>
					`${teacherInfo.value?.nickname || "老師"}, 命理老師, 八字算命, 占卜服務, 命理諮詢, 先知命局`
			),
		},
		{
			name: "description",
			content: computed(() =>
				teacherInfo.value?.nickname
					? `${teacherInfo.value.nickname} - 先知命局專業命理老師，提供精準的八字算命、占卜諮詢服務。${teacherInfo.value.introduce || "專業分析將幫助您預測未來運勢，提供事業、健康、財富等方面的指引。"}`
					: "先知命局專業命理老師，提供精準的八字算命、占卜諮詢服務。專業分析將幫助您預測未來運勢，提供事業、健康、財富等方面的指引。"
			),
		},
		{
			property: "og:title",
			content: computed(() => teacherInfo.value?.nickname || "老師詳情 - 先知命局"),
		},
		{
			property: "og:description",
			content: computed(() =>
				teacherInfo.value?.nickname
					? `${teacherInfo.value.nickname} - 先知命局專業命理老師`
					: "先知命局專業命理老師"
			),
		},
		{
			property: "og:image",
			content: computed(() => teacherInfo.value?.avatar || "/logo.png"),
		},
		{
			property: "og:type",
			content: "profile",
		},
	],
});

// 动态导入组件（代码分割）
const DynamicComponent = $isMobile
	? defineAsyncComponent(() => import("@variants/seer/teacher-detail/m/index.vue"))
	: defineAsyncComponent(() => import("@variants/seer/teacher-detail/pc/index.vue"));
</script>

<template>
	<DynamicComponent />
</template>
